<div>
  <div class="product-overview">
    <div class="product-id">
      <va-icon [iconUrl]="iconUrl" [iconName]="title" [diameter]="75"></va-icon>

      <div class="product-id-text">
        <mat-card-title
          [ngClass]="{
            'stencil-title stencil-shimmer': !title,
          }"
          >
          {{ title }}
        </mat-card-title>

        <mat-card-subtitle
          [ngClass]="{
            'stencil-tagline stencil-shimmer': !title && !tagline,
            tagline: tagline
          }"
          >
          {{ tagline }}
        </mat-card-subtitle>

        @if (prerequisite) {
          <div class="prerequisite">
            <span class="requires-text">
              {{ 'FRONTEND.STORE.REQUIRES' | translate }}
            </span>
            <span>{{ prerequisite }}</span>
          </div>
        }

        @if (!this.hideTags) {
          <mat-chip-listbox>
            @for (chip of chipLabels; track chip) {
              <mat-chip-option>
                {{ chip | translate }}
              </mat-chip-option>
            }
          </mat-chip-listbox>
        }
      </div>
    </div>

    <div class="pricing">
      @if (showAction && !showEnableAddon) {
        <button
          mat-flat-button
          class="app-enable-button"
          [disabled]="!actionEnabled"
          (click)="onActionSelected()"
          >
          {{ actionLabel }}
        </button>
      }

      @if (!actionEnabled) {
        <button mat-stroked-button class="contact-button" (click)="handleContactActionClick()">
          {{ 'FRONTEND.STORE.CONTACT_US' | translate }}
        </button>
      }

      @if (showEnableAddon && !showAction) {
        <button
          mat-flat-button
          class="app-enable-button"
          [disabled]="!showEnableAddon"
          (click)="onActionSelected()"
          >
          {{ actionLabel }}
        </button>
      }

      @if (prerequisiteLabel && !showEnableAddon) {
        <div class="addon-enable" (click)="onPrerequisiteSelected()">
          {{ 'FRONTEND.STORE.ENABLED_WITH_PREREQUISITE' | translate : { prerequisite: prerequisiteLabel } }}
        </div>
      }

      @if (showPricing) {
        <div class="price-box">
          @if (appPrice) {
            <billing-ui-price-display
              [appPrice]="appPrice"
              [form]="'verbose'"
              [currencyCode]="partnerCurrency"
              [size]="'large'"
            ></billing-ui-price-display>
          }
        </div>
      }

      @if (pricingActionEnabled) {
        <p class="pricing-action-container">
          <a (click)="primaryPricingActionSelected.emit()">
            {{ primaryPricingActionLabel }}
          </a>
          <a (click)="pricingActionSelected.emit()">{{ pricingActionLabel }}</a>
        </p>
      }
    </div>
  </div>
</div>
